// extracted by mini-css-extract-plugin
module.exports = {"SideBarItems":"SideBarItems__SideBarItems___1jWxF","SideBarItem":"SideBarItems__SideBarItem___2avmj","SideBarItemInactive":"SideBarItems__SideBarItemInactive___3eT09"};